export const INVALID_NAMES_CONSTANTS: string[] = [
    "---",
    "------",
    "--------------------",
    "AAA",
    "AAAAAAA",
    "ABCD ABCD",
    "ASDS",
    "BASURA",
    "BBB",
    "CIA",
    "DEPARTAMENTO",
    "DGFG",
    "DPTO",
    "ERRADA",
    "ERRADO",
    "GGG",
    "HDHD",
    "HERRADO",
    "JAJAJAJA",
    "JJJ",
    "JJJJ",
    "KKK",
    "LIMITADA",
    "LLLL",
    "LTD.",
    "LTDA",
    "MMM",
    "MMMM",
    "NA",
    "NN",
    "NNN",
    "NO SE SABE",
    "NOMBRE",
    "NULL",
    "NULO",
    "OTRO",
    "PRUEBA",
    "S.A.",
    "SA.",
    "SDFSDFSDF",
    "SIN",
    "SSSS",
    "USUARIO",
    "XXX",
    "XXXX",
    "XXXXX",
    "XXXXXXX",
    "XXXXXXXXX",
    "BB",
    "BBBBBBB",
    "CEL",
    "CC",
    "CCCCC",
    "DE",
    "DDD",
    "EEEEHHHH",
    "EH",
    "EEEE",
    "FEE",
    "FFFFF",
];

export const INVALID_LAST_NAMES_CONSTANTS: string[] = [
    "---",
    "------",
    "--------------------",
    "AAA",
    "AAAAAAA",
    "ABCD ABCD",
    "ASDS",
    "BASURA",
    "BBB",
    "CIA",
    "DEPARTAMENTO",
    "DGFG",
    "DPTO",
    "ERRADA",
    "ERRADO",
    "GGG",
    "HDHD",
    "HERRADO",
    "JAJAJAJA",
    "JJJ",
    "JJJJ",
    "KKK",
    "LIMITADA",
    "LLLL",
    "LTD.",
    "LTDA",
    "MMM",
    "MMMM",
    "NA",
    "NN",
    "NNN",
    "NO SE SABE",
    "NULL",
    "NULO",
    "OTRO",
    "PRUEBA",
    "NOMBRE",
    "S.A.",
    "SA.",
    "SDFSDFSDF",
    "SIN",
    "SSSS",
    "USUARIO",
    "XXX",
    "XXXX",
    "XXXXX",
    "XXXXXXX",
    "XXXXXXXXX",
];